import { API } from "aws-amplify";
import { getOffer } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_OFFER_INFO: APITypes.Offer = {
  id: "",
  status: APITypes.OfferStatusType.Pending,
  startDate: "",
  endDate: "",
  tenantSignDate: "",
  landlordSignDate: "",
  __typename: "Offer",
  createdAt: "",
  updatedAt: "",
  rent: 0,
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getOfferInfo = async (
  OfferID: string
): Promise<LoaderData<APITypes.Offer>> => {
  try {
    const response = (await API.graphql({
      query: getOffer,
      variables: {
        id: OfferID,
      },
    })) as { data?: APITypes.GetOfferQuery };

    return {
      success: true,
      data: response.data?.getOffer || EMPTY_OFFER_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_OFFER_INFO,
      error,
    };
  }
};
